import createTxpStrings from './createTxpStrings';
import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';
import { CardItem } from 'txp-data';

/** returns a string to be used for aria text */
export default function getAriaText(cardItem: CardItem, strings?: string[]): string {
    let ariaText: string = '';
    let { detailsData } = cardItem;
    const txpStrings = createTxpStrings();

    if (cardItem && cardItem.entityType === EntityType.ServiceReservation) {
        ariaText = txpStrings.formatters.format(
            txpStrings.strings.eventAriaFormatText,
            cardItem.ariaTime,
            cardItem.detailsData && detailsData.secondLine && detailsData.secondLine.text,
            null,
            null,
            strings && strings[0]
        );
    }

    return ariaText;
}
